
<b-modal
    id="createUser"
    title="Skapa ny användare"
    hide-footer
    no-fade
    ref="createusermodal"
>
    <b-form @submit="onSubmit" autocomplete="off">
        <b-form-group
            id="user-email"
            label-for="user-email-input"
            description="Ange skrivtolkens epostadress. Denna används för inloggning."
        >
            <b-form-input
                type="email"
                v-model="form.email"
                :state="validateEmail"
                id="user-email-input"
                required
            />
        </b-form-group>
        <b-form-group
            id="user-name"
            label-for="user-name-input"
            description="Ange skrivtolkens namn."
        >
            <b-form-input
                type="text"
                v-model="form.name"
                id="user-name-input"
                required
            />
        </b-form-group>
        <b-form-group
            id="user-role"
            label-for="user-role-select"
            description="Bestäm användarens behörighetsnivå (roll)"
        >
            <b-form-select :options="roles" v-model="form.role" />
        </b-form-group>
        <b-row>
            <b-col cols="7" />
            <b-col>
                <b-button variant="danger" @click="closeModal">
                    Avbryt
                </b-button>
                <b-button type="submit" variant="primary">
                    Lägg till
                </b-button>
            </b-col>
        </b-row>
    </b-form>
</b-modal>
